/**
 * Joins class names to a string, filtering out falsy values
 */
export function classArr(
	...classes: (string | false | 0 | 0n | "" | null | undefined)[]
) {
	return classes.filter((entry) => !!entry).join(" ");
}
